import { supabase } from "@/integrations/supabase/client";

/** Detect device type from screen width */
export function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
  if (typeof window === 'undefined') return 'desktop';
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
}

/** Parse basic browser/OS from user agent */
export function parseBrowserOS(): { browser: string; os: string } {
  if (typeof navigator === 'undefined') return { browser: 'unknown', os: 'unknown' };
  const ua = navigator.userAgent;
  let browser = 'Other';
  if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('OPR/') || ua.includes('Opera/')) browser = 'Opera';
  else if (ua.includes('Chrome/') && !ua.includes('Edg/')) browser = 'Chrome';
  else if (ua.includes('Safari/') && !ua.includes('Chrome/')) browser = 'Safari';

  let os = 'Other';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS')) os = 'macOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('CrOS')) os = 'ChromeOS';

  return { browser, os };
}

/** Log login session with device info (fire-and-forget) */
export function logLoginSession(userId: string) {
  try {
    const deviceType = getDeviceType();
    const { browser, os } = parseBrowserOS();
    supabase
      .from('login_sessions')
      .insert({
        user_id: userId,
        device_type: deviceType,
        browser,
        os,
        screen_width: typeof window !== 'undefined' ? window.innerWidth : null,
        screen_height: typeof window !== 'undefined' ? window.innerHeight : null,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 500) : null,
      // login_sessions table is not in generated Supabase types
      } as Record<string, unknown>)
      .then(() => {})
      .catch((err: unknown) => console.debug('Login session log failed:', err));
  } catch {
    // Silent fail — logging should never break auth
  }
}
